import _regenerator from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getCouponDetail, overlapCouponName, overlapCouponCode, createCoupon, updateCoupon } from '@/api/coupon';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, default_1, [].concat(args));
    _defineProperty(_this, "couponId", void 0);
    _defineProperty(_this, "visible", void 0);
    _defineProperty(_this, "isEdit", void 0);
    _defineProperty(_this, "rangePicker", []);
    _defineProperty(_this, "stockFree", true);
    _defineProperty(_this, "pickerOptions", {});
    _defineProperty(_this, "updateOldData", {});
    _defineProperty(_this, "loading", false);
    _defineProperty(_this, "form", null);
    _defineProperty(_this, "formLabelWidth", '120px');
    _defineProperty(_this, "rules", {});
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function () {
      var _created = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var update, create, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.rules = {
                name: [{
                  required: true,
                  message: this.$t('coupon.list.modal.keys.validationErrorMsg.name.required'),
                  trigger: 'blur'
                }],
                code: [{
                  required: true,
                  message: this.$t('coupon.list.modal.keys.validationErrorMsg.code.required'),
                  trigger: 'blur'
                }]
              };
              if (!this.isEdit) {
                _context.n = 5;
                break;
              }
              update = {
                id: this.couponId,
                name: '',
                code: '',
                use_yn: 'N',
                use_start_date: '',
                use_end_date: '',
                benefit_period: 0,
                stock: 0,
                stock_free_yn: 'Y',
                coupon_type: 1
              };
              this.form = Object.assign({}, update);
              _context.p = 1;
              _context.n = 2;
              return getCouponDetail({
                id: this.couponId
              });
            case 2:
              this.form = _context.v;
              this.rangePicker = [new Date(this.form.use_start_date), new Date(this.form.use_end_date)];
              if (this.form.stock_free_yn === 'Y') {
                this.stockFree = true;
              } else {
                this.stockFree = false;
              }
              this.updateOldData.name = this.form.name;
              this.updateOldData.code = this.form.code;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.log('error : ', _t);
            case 4:
              _context.n = 6;
              break;
            case 5:
              create = {
                name: '',
                code: '',
                use_yn: 'N',
                use_start_date: '',
                use_end_date: '',
                benefit_period: 0,
                stock: 0,
                stock_free_yn: 'Y',
                coupon_type: 1
              };
              this.form = Object.assign({}, create);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function created() {
        return _created.apply(this, arguments);
      }
      return created;
    }()
  }, {
    key: "noti",
    value: function noti(message, mode) {
      if (mode === 'success') {
        this.$notify({
          title: 'Success',
          message: message,
          type: 'success'
        });
      } else {
        this.$notify({
          title: 'Warning',
          message: message,
          type: 'warning'
        });
      }
    }
  }, {
    key: "validationOverlapName",
    value: function () {
      var _validationOverlapName = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(isValid) {
        var resOverlapName;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return overlapCouponName({
                name: this.form.name
              });
            case 1:
              resOverlapName = _context2.v;
              if (resOverlapName === true) {
                isValid = false;
                this.noti(this.$t('coupon.list.modal.keys.validationErrorMsg.name.overlap').toString());
              }
              return _context2.a(2, isValid);
          }
        }, _callee2, this);
      }));
      function validationOverlapName(_x) {
        return _validationOverlapName.apply(this, arguments);
      }
      return validationOverlapName;
    }()
  }, {
    key: "validationOverlapCode",
    value: function () {
      var _validationOverlapCode = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(isValid) {
        var resOverlapCode;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return overlapCouponCode({
                code: this.form.code
              });
            case 1:
              resOverlapCode = _context3.v;
              if (resOverlapCode === true) {
                isValid = false;
                this.noti(this.$t('coupon.list.modal.keys.validationErrorMsg.code.overlap').toString());
              }
              return _context3.a(2, isValid);
          }
        }, _callee3, this);
      }));
      function validationOverlapCode(_x2) {
        return _validationOverlapCode.apply(this, arguments);
      }
      return validationOverlapCode;
    }()
  }, {
    key: "handleSubmit",
    value: function () {
      var _handleSubmit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var isValid, res, _t2;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              isValid = true;
              if (this.form.name === null || this.form.name === '') {
                isValid = false;
                this.noti(this.$t('coupon.list.modal.keys.validationErrorMsg.name.required').toString());
              }
              if (this.form.code === null || this.form.code === '') {
                isValid = false;
                this.noti(this.$t('coupon.list.modal.keys.validationErrorMsg.code.required').toString());
              }
              if (this.rangePicker === null || this.rangePicker.length === 0) {
                isValid = false;
                this.noti(this.$t('coupon.list.modal.keys.validationErrorMsg.rangePicker.required').toString());
              }
              _context4.p = 1;
              if (!this.isEdit) {
                _context4.n = 6;
                break;
              }
              if (!(this.form.name !== this.updateOldData.name)) {
                _context4.n = 3;
                break;
              }
              _context4.n = 2;
              return this.validationOverlapName(isValid);
            case 2:
              isValid = _context4.v;
            case 3:
              if (!(this.isEdit && this.form.code !== this.updateOldData.code)) {
                _context4.n = 5;
                break;
              }
              _context4.n = 4;
              return this.validationOverlapCode(isValid);
            case 4:
              isValid = _context4.v;
            case 5:
              _context4.n = 9;
              break;
            case 6:
              _context4.n = 7;
              return this.validationOverlapName(isValid);
            case 7:
              isValid = _context4.v;
              _context4.n = 8;
              return this.validationOverlapCode(isValid);
            case 8:
              isValid = _context4.v;
            case 9:
              _context4.n = 11;
              break;
            case 10:
              _context4.p = 10;
              _t2 = _context4.v;
              isValid = false;
            case 11:
              if (!isValid) {
                _context4.n = 16;
                break;
              }
              if (!this.isEdit) {
                _context4.n = 13;
                break;
              }
              _context4.n = 12;
              return updateCoupon(this.form);
            case 12:
              res = _context4.v;
              _context4.n = 15;
              break;
            case 13:
              _context4.n = 14;
              return createCoupon(this.form);
            case 14:
              res = _context4.v;
            case 15:
              if (res === true) {
                this.noti(this.$t('coupon.list.modal.save.success').toString(), 'success');
                this.$emit('modalComplete');
                this.handleClose();
              } else {
                this.noti(this.$t('coupon.list.modal.save.fail').toString());
              }
            case 16:
              return _context4.a(2);
          }
        }, _callee4, this, [[1, 10]]);
      }));
      function handleSubmit() {
        return _handleSubmit.apply(this, arguments);
      }
      return handleSubmit;
    }() // 로컬타임 보내야함. 서버에서 utc 맞춤
  }, {
    key: "handleGetLocalTimetoISOString",
    value: function handleGetLocalTimetoISOString(date) {
      var res = new Date(date).getTime();
      if (new Date(date).getTimezoneOffset() < 0) {
        res += new Date(date).getTimezoneOffset() * -1 * 60 * 1000;
      } else {
        res -= new Date(date).getTimezoneOffset() * 60 * 1000;
      }
      return new Date(res).toISOString();
    }
  }, {
    key: "handleRangePicker",
    value: function handleRangePicker(val) {
      if (val !== null) {
        this.form.use_start_date = this.handleGetLocalTimetoISOString(val[0]);
        this.form.use_end_date = this.handleGetLocalTimetoISOString(val[1]);
      }
    }
  }, {
    key: "handleStockFree",
    value: function handleStockFree(val) {
      if (val) {
        this.form.stock_free_yn = 'Y';
      } else {
        this.form.stock_free_yn = 'N';
      }
    }
  }, {
    key: "filterModalTitle",
    value: function filterModalTitle() {
      if (this.isEdit) {
        return this.$t('coupon.list.modal.editTitle');
      }
      return this.$t('coupon.list.modal.addTitle');
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.$emit('update:visible', false);
    }
  }, {
    key: "handleOpen",
    value: function handleOpen() {}
  }]);
}(Vue);
__decorate([Prop({
  required: false
})], default_1.prototype, "couponId", void 0);
__decorate([Prop({
  required: false
})], default_1.prototype, "visible", void 0);
__decorate([Prop({
  required: true
})], default_1.prototype, "isEdit", void 0);
default_1 = __decorate([Component({
  name: 'UpsertModal'
})], default_1);
export default default_1;